/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData model module.
 * @module model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData
 * @version 1.0
 */
class LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData</code>.
     * @alias module:model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData} The populated <code>LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData();

            if (data.hasOwnProperty('walletTransactionInventoryNo')) {
                obj['walletTransactionInventoryNo'] = ApiClient.convertToType(data['walletTransactionInventoryNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'Number');
            }
            if (data.hasOwnProperty('itemId1')) {
                obj['itemId1'] = ApiClient.convertToType(data['itemId1'], 'Number');
            }
            if (data.hasOwnProperty('itemCount1')) {
                obj['itemCount1'] = ApiClient.convertToType(data['itemCount1'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount1')) {
                obj['beforeItemCount1'] = ApiClient.convertToType(data['beforeItemCount1'], 'Number');
            }
            if (data.hasOwnProperty('itemId2')) {
                obj['itemId2'] = ApiClient.convertToType(data['itemId2'], 'Number');
            }
            if (data.hasOwnProperty('itemCount2')) {
                obj['itemCount2'] = ApiClient.convertToType(data['itemCount2'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount2')) {
                obj['beforeItemCount2'] = ApiClient.convertToType(data['beforeItemCount2'], 'Number');
            }
            if (data.hasOwnProperty('itemId3')) {
                obj['itemId3'] = ApiClient.convertToType(data['itemId3'], 'Number');
            }
            if (data.hasOwnProperty('itemCount3')) {
                obj['itemCount3'] = ApiClient.convertToType(data['itemCount3'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount3')) {
                obj['beforeItemCount3'] = ApiClient.convertToType(data['beforeItemCount3'], 'Number');
            }
            if (data.hasOwnProperty('itemId4')) {
                obj['itemId4'] = ApiClient.convertToType(data['itemId4'], 'Number');
            }
            if (data.hasOwnProperty('itemCount4')) {
                obj['itemCount4'] = ApiClient.convertToType(data['itemCount4'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount4')) {
                obj['beforeItemCount4'] = ApiClient.convertToType(data['beforeItemCount4'], 'Number');
            }
            if (data.hasOwnProperty('itemId5')) {
                obj['itemId5'] = ApiClient.convertToType(data['itemId5'], 'Number');
            }
            if (data.hasOwnProperty('itemCount5')) {
                obj['itemCount5'] = ApiClient.convertToType(data['itemCount5'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount5')) {
                obj['beforeItemCount5'] = ApiClient.convertToType(data['beforeItemCount5'], 'Number');
            }
            if (data.hasOwnProperty('itemId6')) {
                obj['itemId6'] = ApiClient.convertToType(data['itemId6'], 'Number');
            }
            if (data.hasOwnProperty('itemCount6')) {
                obj['itemCount6'] = ApiClient.convertToType(data['itemCount6'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount6')) {
                obj['beforeItemCount6'] = ApiClient.convertToType(data['beforeItemCount6'], 'Number');
            }
            if (data.hasOwnProperty('itemId7')) {
                obj['itemId7'] = ApiClient.convertToType(data['itemId7'], 'Number');
            }
            if (data.hasOwnProperty('itemCount7')) {
                obj['itemCount7'] = ApiClient.convertToType(data['itemCount7'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount7')) {
                obj['beforeItemCount7'] = ApiClient.convertToType(data['beforeItemCount7'], 'Number');
            }
            if (data.hasOwnProperty('itemId8')) {
                obj['itemId8'] = ApiClient.convertToType(data['itemId8'], 'Number');
            }
            if (data.hasOwnProperty('itemCount8')) {
                obj['itemCount8'] = ApiClient.convertToType(data['itemCount8'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount8')) {
                obj['beforeItemCount8'] = ApiClient.convertToType(data['beforeItemCount8'], 'Number');
            }
            if (data.hasOwnProperty('itemId9')) {
                obj['itemId9'] = ApiClient.convertToType(data['itemId9'], 'Number');
            }
            if (data.hasOwnProperty('itemCount9')) {
                obj['itemCount9'] = ApiClient.convertToType(data['itemCount9'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount9')) {
                obj['beforeItemCount9'] = ApiClient.convertToType(data['beforeItemCount9'], 'Number');
            }
            if (data.hasOwnProperty('itemId10')) {
                obj['itemId10'] = ApiClient.convertToType(data['itemId10'], 'Number');
            }
            if (data.hasOwnProperty('itemCount10')) {
                obj['itemCount10'] = ApiClient.convertToType(data['itemCount10'], 'Number');
            }
            if (data.hasOwnProperty('beforeItemCount10')) {
                obj['beforeItemCount10'] = ApiClient.convertToType(data['beforeItemCount10'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} walletTransactionInventoryNo
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['walletTransactionInventoryNo'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} transactionType
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['transactionType'] = undefined;

/**
 * @member {Number} itemId1
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId1'] = undefined;

/**
 * @member {Number} itemCount1
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount1'] = undefined;

/**
 * @member {Number} beforeItemCount1
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount1'] = undefined;

/**
 * @member {Number} itemId2
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId2'] = undefined;

/**
 * @member {Number} itemCount2
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount2'] = undefined;

/**
 * @member {Number} beforeItemCount2
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount2'] = undefined;

/**
 * @member {Number} itemId3
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId3'] = undefined;

/**
 * @member {Number} itemCount3
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount3'] = undefined;

/**
 * @member {Number} beforeItemCount3
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount3'] = undefined;

/**
 * @member {Number} itemId4
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId4'] = undefined;

/**
 * @member {Number} itemCount4
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount4'] = undefined;

/**
 * @member {Number} beforeItemCount4
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount4'] = undefined;

/**
 * @member {Number} itemId5
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId5'] = undefined;

/**
 * @member {Number} itemCount5
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount5'] = undefined;

/**
 * @member {Number} beforeItemCount5
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount5'] = undefined;

/**
 * @member {Number} itemId6
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId6'] = undefined;

/**
 * @member {Number} itemCount6
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount6'] = undefined;

/**
 * @member {Number} beforeItemCount6
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount6'] = undefined;

/**
 * @member {Number} itemId7
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId7'] = undefined;

/**
 * @member {Number} itemCount7
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount7'] = undefined;

/**
 * @member {Number} beforeItemCount7
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount7'] = undefined;

/**
 * @member {Number} itemId8
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId8'] = undefined;

/**
 * @member {Number} itemCount8
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount8'] = undefined;

/**
 * @member {Number} beforeItemCount8
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount8'] = undefined;

/**
 * @member {Number} itemId9
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId9'] = undefined;

/**
 * @member {Number} itemCount9
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount9'] = undefined;

/**
 * @member {Number} beforeItemCount9
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount9'] = undefined;

/**
 * @member {Number} itemId10
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemId10'] = undefined;

/**
 * @member {Number} itemCount10
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['itemCount10'] = undefined;

/**
 * @member {Number} beforeItemCount10
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['beforeItemCount10'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['createdAt'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData.prototype['email'] = undefined;






export default LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData;

